export default __webpack_public_path__ + "static/media/bg_outline1.19aac26e.png";